<template>
    <v-dialog max-width="500px"  v-model="show">
    <DlgMessage ref="dlgMsg" @dlgClose="dlgClose"></DlgMessage>
        <v-card>
          <v-toolbar flat dark color="panel1">
            <v-toolbar-title>Add New Outlet</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="show=false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
            <div class="pa-5">

                            <v-row no-gutters>
                    <v-col cols="12">

                <v-form ref="mainForm">
                    <v-select
                        v-model = "form.merchant_id"
                        :items="merchantList"
                        item-text="merchant_name"
                        item-value="merchant_id"
                        label="Merchant"
                        standard
                        :rules="inputRules"
                        outlined
                        v-if="show" autofocus
                    ></v-select>
                    <v-text-field 
                        v-model="form.outlet_code" label="Code" :rules="inputRules" 
                        outlined
                        v-if="show" autofocus  
                    ></v-text-field>
                    <v-text-field v-model="form.outlet_name" label="Name" :rules="inputRules" outlined></v-text-field>
                    <v-select
                        v-model = "form.outlet_type_code"
                        :items="outletTypeList"
                        item-text="description"
                        item-value="code"
                        label="Type"
                        standard
                        :rules="inputRules"
                        outlined
                    ></v-select>                    

                    <v-spacer></v-spacer>
                </v-form>
                    </v-col>
                            </v-row>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="cbtnSave" dark @click="save">
                    <v-icon left dark>mdi-check</v-icon>
                    Submit
                </v-btn>
                <v-btn class="ml-2" color="cbtnRed" dark @click="show=false">
                    <v-icon left dark>mdi-close</v-icon>
                    Close
                </v-btn>
            </v-card-actions>

          </v-card>
    </v-dialog>

</template>

<script>
import DlgMessage from '@/components/DlgMessage'
import ApMerchantService from "@/services/ApMerchantService"
import ApParameterService from "@/services/ApParameterService"
export default {
    name: "DlgMerchantOutletAdd",
    props: {
        visible:Boolean,
    },      
    components:{DlgMessage},
    computed: {
      show: {
        get () {
          return this.visible
        },
        set (value) {
           if (!value) {
                this.$emit('close')
           }
        }
      },
      outletListFiltered(){
          return this.outletList.filter(item => item.merchant_id === this.form.merchant_id)
        },

      
    },
    data(){
        return{
            dialog: false,
            form:{
                login_id: "",
                merchant_id: 0,
                outlet_code: "",
                outlet_name: "",
                status: "ACTIVE"
            },
            merchantList: [],
            outletTypeList:[],
            error_message:'',
            error_code: '200',
            inputRules: [
             v => !!v || 'This field is required'
            ]
        }
    },
    async created() {
//        this.$refs.mainForm.reset()
        this.getParameter();
      //this.viewMerchantEdc();
    },
     
    methods:{
   dlgShow(){
    },
    dlgClose(){
        console.log(this.respCode);
        
        if(this.respCode == 200){
            this.form.c_code = "";
            this.form.c_name = "";
            this.form.sequence = 0;
            this.show = false;
        }
            
    },                
        async save(){
            console.log(this.form);
            if(this.$refs.mainForm.validate()) {
                try{
                
                    ApMerchantService.insert_merchant_outlet(this.form).then(() => {
                        //console.log(res);
                        this.$refs.dlgMsg.showDlgBox(true,'success','New Outlet','Success.');
                    }).catch((e)=>{
                        //console.log(e.response);
                        this.$refs.dlgMsg.showDlgBox(true,'error','New Outlet',e.response.data.error_message);
                    })
                    ;
                } catch(e) {
                    this.loadingFlag = false
                    this.$refs.dlgMsg.showDlgBox(true,'error','New Outlet','Unknown Error');
                    
                } 
            }

        },
        async getParameter(){
            try{
                let parameter = {login_id:"",param_type:"add-merchant_outlet"}
                ApParameterService.get_parameter(parameter).then((res) => {
                    this.merchantList = res.data.merchantList;
                    this.outletTypeList = res.data.OutletTypeList;
                    console.log(res.data);
                    
                }).catch((e)=>{
                    console.log(e.response);
                    this.$refs.dlgMsg.showDlgBox(true,'error','View Outlet',e.response.data.error_message);
                })
                ;
            } catch(e) {
                console.log(e);
                //this.$refs.dlgMsg.showDlgBox(true,'error','Supplier','Unknown Error');
            }
        },
        
    }
}    

</script>